import type { AttributesEmbed } from '@/elements/embed/attributes'
import { validate } from '@/helpers/validate'
import type { ScalarGuideElement } from '@/types'
import { attributesEmbedSchema } from '@/elements/embed/attributes'
import { guideEmbedHtml } from '@/elements/embed/component'

export type { AttributesEmbed } from '@/elements/embed/attributes'
export { ScalarEmbedVue } from '@/elements/embed/component'

export const scalarEmbed: ScalarGuideElement<AttributesEmbed, 'scalar-embed'> =
  {
    name: 'scalar-embed',
    tagName: 'scalar-embed',
    tiptapName: 'custom_embed',

    attributeTransform: (content, attrs) => {
      const isMissingCaption = attrs.caption === undefined
      return validate(attributesEmbedSchema, {
        ...attrs,
        ...(isMissingCaption ? { caption: content } : {}),
      })
    },

    render: async (props) => {
      const validated = validate(attributesEmbedSchema, props)
      return validated ? guideEmbedHtml(validated) : ''
    },
  }
